import { CeruleanButton } from 'components/Button'
import Field from 'components/Field'
import Input from 'components/Input'
import InputContainer from 'components/InputContainer'
import { OverlayLoader } from 'components/Loaders'
import formName from 'constants/formName'
import { selectors } from 'data'
import { ForgotPasswordFormType } from 'data/Form/ForgotPassword/types'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { InjectedFormProps, reduxForm } from 'redux-form'
import styled from 'styled-components'
import { validator } from 'utils'

import asyncValidate from '../Modal/asyncValidatePassword'
import Container from '../Modal/Container'
import { ResetPasswordStrength } from '../Modal/PasswordStrength'
import { Props as _P } from '.'

const isSameAsPassword = validator.isSameAs('newPassword')

const PasswordContainer = styled.div`
  position: relative;
`

// eslint-disable-next-line react/no-unused-prop-types
type NotFormProps = _P & WrappedComponentProps & { form: string }
type PropsType = InjectedFormProps<ForgotPasswordFormType, NotFormProps> & NotFormProps

const ResetPassword = ({ fieldLoading, handleSubmit, intl, isLoading, valid }: PropsType) => (
  <form
    onSubmit={(e) => {
      e.preventDefault()
      handleSubmit()
    }}
  >
    <Container title={intl.formatMessage(messages.title_reset_password)}>
      <PasswordContainer>
        <ResetPasswordStrength />

        <InputContainer>
          <Field
            asyncValidate
            autoComplete='new-password'
            component={Input}
            data-lpignore='true'
            e2e='newPasswordInput'
            label={intl.formatMessage(messages.label_password_new)}
            loading={fieldLoading === 'newPassword'}
            name='newPassword'
            placeholder={intl.formatMessage(messages.placeholder_password_new)}
            showPassword
            type='password'
            validate={[validator.required]}
          />
        </InputContainer>
      </PasswordContainer>

      <InputContainer>
        <Field
          autoComplete='new-password'
          component={Input}
          data-lpignore='true'
          e2e='confirmPasswordInput'
          label={intl.formatMessage(messages.label_confirm_new_password)}
          name='passwordBis'
          type='password'
          validate={[validator.required, isSameAsPassword]}
        />
      </InputContainer>

      <CeruleanButton disabled={!valid} e2e='resetPasswordButton' type='submit'>
        {intl.formatMessage(messages.button_reset_password)}
      </CeruleanButton>
    </Container>

    {isLoading && <OverlayLoader />}
  </form>
)

export default injectIntl(
  reduxForm<ForgotPasswordFormType, NotFormProps>({
    asyncChangeFields: ['newPassword'],
    asyncValidate,
    form: formName.FORGOT_PASSWORD,
    initialValues: selectors.forgotPassword.initialValues
  })(ResetPassword)
)
